import {type TariffsConfig, createGetPath} from '@yandex-delivery/modules/tariffs-v3'

import {config} from './config'
import {PATH_TO_ORDER} from './consts'
import {suggestService, tariffsService} from './shared/api'

const {mapLang, location, branding, lang, basename, detectedCountry, version, yaAuthProxyHost} = config.config

export const tariffsConfig: TariffsConfig = {
  pathToCreateOrder: PATH_TO_ORDER,
  mapLang,
  location,
  brand: branding,
  lang,
  tariffsService,
  suggestService,
  getPath: createGetPath(),
  basename,
  countryCode: detectedCountry,
  version,
  yaAuthProxyHost,
}
